var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('TaskDisplay',{attrs:{"task":_vm.task},on:{"reload":function($event){return _vm.loadTask(_vm.task.taskId)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }